import React from 'react';
import { Link } from 'react-router-dom';
import { Nav } from "react-bootstrap"
import { FaTachometerAlt, FaUsersCog, FaCogs, FaChartLine, FaTable } from 'react-icons/fa'
const Sidebar = () => {
        return (
            <div className="first-sidemenu ps" id="accordior">

                <Nav className="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion" as="ul">
                    {/* <!-- Divider --> */}
                    <div className="sidebar-divider my-0"></div>

                    {/* <!-- Nav Item - Dashboard --> */}
                    {((localStorage.getItem("isViewTenantUserRole")) || (localStorage.getItem("isP2PRole"))) ?
                    <Nav.Item as="li" className="nav-item mt-3">
                        <Link to="/Dashboard" className="nav-link active">
                            <FaTachometerAlt className="fas fa-fw" style={{width: '1.5rem', height: '1.5rem'}} /><span>Dashboard</span>
                        </Link>
                    </Nav.Item>
                    : null }
                    {/* <!-- Nav Item - Pages Collapse Menu --> */}
                    { (localStorage.getItem("isViewUserRole")) ?
                    <Nav.Item as="li" className="nav-item">
                        <Link to="/ManageUser" className="nav-link">
                            <FaUsersCog className="fas fa-fw" style={{width: '1.7rem', height: '1.7rem'}} /><span>Manage User</span>
                        </Link>
                    </Nav.Item>
                    : null }
                    { (localStorage.getItem("isViewTenantRole")) ?
                    <Nav.Item as="li" className="nav-item">
                        <Link to="/ManageTenant" className="nav-link">
                            <FaCogs className="fas fa-fw" style={{width: '1.7rem', height: '1.7rem'}} /><span>Manage Tenants</span>
                        </Link>
                    </Nav.Item>
                    : null }
                    { (localStorage.getItem("isViewTenantUserRole")) ?
                    <Nav.Item as="li" className="nav-item">
                        <Link to="/ManageTenantUser" className="nav-link">
                            <FaUsersCog className="fas fa-fw" style={{width: '1.7rem', height: '1.7rem'}} /><span>Manage Tenant Users</span>
                        </Link>
                    </Nav.Item>
                    : null }
                    { (localStorage.getItem("isViewMISRole")) ?
                    <Nav.Item as="li" className="nav-item">
                        <Link to="/home" className="nav-link">
                            <FaChartLine className="fas fa-fw" style={{width: '1.7rem', height: '1.7rem'}} /><span>MIS</span>
                        </Link>
                    </Nav.Item>
                    : null }
                    
                    { (localStorage.getItem("isViewOCRRole")) ?
                        <Nav.Item as="li" className="nav-item">
                        <Link to="/ocrReport" className="nav-link">
                            <FaTable className="fas fa-fw" style={{width: '1.7rem', height: '1.7rem'}} /><span>Ocr Report</span>
                        </Link>
                    </Nav.Item>
                    : null }
                </Nav>
            </div>
        ) 
    }
export default Sidebar;